<script>
import { Message } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      hideSubmit: true,
      redirectRoute: { name: 'Message List' }
    }
  },
  computed: {
    service() {
      return Message
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Imię',
          modelPath: [this, 'form', 'first_name'],
          disabled: true
        }),
        new fields.Input({
          label: 'Nazwisko',
          modelPath: [this, 'form', 'last_name'],
          disabled: true
        }),
        new fields.Input({
          label: 'Email',
          type: 'email',
          modelPath: [this, 'form', 'email'],
          disabled: true
        }),
        new fields.Input({
          label: 'Firma',
          modelPath: [this, 'form', 'company'],
          disabled: true
        }),
        new fields.Select({
          label: 'Jak o nas usłyszałeś?',
          modelPath: [this, 'form', 'source'],
          disabled: true,
          options: [
            { label: 'Google', value: 'google' },
            { label: 'Facebook', value: 'facebook' },
            { label: 'Twitter', value: 'twitter' },
            { label: 'Instagram', value: 'instagram' }
          ]
        }),
        new fields.Input({
          label: 'Treść',
          type: 'textarea',
          modelPath: [this, 'form', 'text'],
          disabled: true
        }),
        new fields.Input({
          label: 'My team size is...',
          modelPath: [this, 'form', 'team_size'],
          disabled: true
        }),
        new fields.Input({
          label: 'Our goal is to...',
          modelPath: [this, 'form', 'goal'],
          disabled: true
        }),
        new fields.Input({
          label: 'For my company or division, these priorities are...',
          modelPath: [this, 'form', 'priorities'],
          disabled: true
        })
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .is-disabled [class$='inner'],
::v-deep .el-select__tags-text {
  color: #303133 !important;
}

::v-deep .el-select {
  &__caret {
    display: none;
  }
}
::v-deep .el-form-item__label {
  width: 100% !important;
  margin-bottom: 0.5rem;
  text-align: left;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
